import { NgModule } from '@angular/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { SharedModule } from '@shared/shared.module';
import { MatSelectModule } from '@angular/material/select';
import { FormWidgetSubscriptionPeriodComponent } from './form-widget-subscription-period.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NumberInputModule } from '@sharedComponents/form/number-input/number-input.module';
import { DateTimeInputModule } from '@sharedComponents/form/date-time-input/date-time-input.module';
import { DateFnsModule } from 'ngx-date-fns';
import { TranslationModule } from '@core/translation/translation.module';

@NgModule({
    declarations: [FormWidgetSubscriptionPeriodComponent],
    imports: [

        FuseSharedModule,
        SharedModule,

        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatButtonModule,
        MatSelectModule,
        MatCheckboxModule,
        MatAutocompleteModule,
        MatProgressSpinnerModule,
        MatTooltipModule,
        NumberInputModule,
        DateTimeInputModule,
        DateFnsModule,
        TranslationModule,
    ],
    exports: [FormWidgetSubscriptionPeriodComponent]
})
export class FormWidgetSubscriptionPeriodModule {
    
}
